import styled from 'styled-components';
import { IoCodeSlash, IoSettingsOutline } from 'react-icons/io5';
import { HiOutlineAdjustmentsHorizontal } from 'react-icons/hi2';

import { AiOutlineFullscreen } from 'react-icons/ai';

import useTabBar from './hooks/useTabBar';
import { RightSideBarTab } from 'types';
import IconButton from 'components/ui/IconButton';
import { IconType } from 'react-icons';
import useRightSideBarFull from 'pages/Editor/hooks/useRightSideBarFull';
import CustomTooltip from 'components/CustomTooltip';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 40px;
  border-left: 1px solid ${(props) => props.theme.global.borderColor};
`;

const TopViewer = styled.div`
  display: flex;
  flex-direction: column;
`;

const BottomViewer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 16px;

  & > div {
    display: flex;
    justify-content: center;
    position: relative;
  }
`;

interface TabProps {
  selectedTab?: RightSideBarTab;
  tab: RightSideBarTab;
  tooltip: string;
  Icon: IconType;
  onTabClick: (newTab: RightSideBarTab) => void;
}

const Tab = ({ selectedTab, tab, tooltip, Icon, onTabClick }: TabProps) => {
  const className = `right-sidebar-tab-${tooltip.replace(' ', '')}`;
  return (
    <div style={{ position: 'relative' }}>
      <IconButton
        className={className}
        $size={90}
        $iconSize={24}
        $isSelected={selectedTab === tab}
        onClick={() => onTabClick(tab)}
        style={{ width: '100%', minWidth: 'initial' }}
      >
        <Icon />
      </IconButton>
      <CustomTooltip anchorSelect={`.${className}`} hasDelay>
        {tooltip}
      </CustomTooltip>
    </div>
  );
};

const TabBar = () => {
  const { selectedTab, selectedNode, onToggleFull, onTabClick } = useTabBar();
  const { isFull } = useRightSideBarFull();

  return (
    <Container>
      <TopViewer>
        <Tab selectedTab={selectedTab} tab="code" tooltip="소스코드" Icon={IoCodeSlash} onTabClick={onTabClick} />
        <Tab
          selectedTab={selectedTab}
          tab="hyperparameter"
          tooltip="하이퍼 파라미터"
          Icon={HiOutlineAdjustmentsHorizontal}
          onTabClick={onTabClick}
        />
        {selectedNode && (
          <Tab
            selectedTab={selectedTab}
            tab="nodeInfo"
            tooltip="노드 정보"
            Icon={IoSettingsOutline}
            onTabClick={onTabClick}
          />
        )}
      </TopViewer>
      <BottomViewer>
        <div>
          <IconButton
            className="right-sidebar-full"
            $size={30}
            $iconSize={24}
            $hasRadius
            $isSelected={isFull}
            onClick={onToggleFull}
          >
            <AiOutlineFullscreen />
          </IconButton>
          <CustomTooltip anchorSelect=".right-sidebar-full" hasDelay>
            창 확대
          </CustomTooltip>
        </div>
      </BottomViewer>
    </Container>
  );
};

export default TabBar;
